import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AddressContextMenu } from '../Presenter/AddressContextMenu';
import { deleteAddress, setEditModeAddress } from '../../../action/account';

class AddressContextMenuContainer extends PureComponent {
  render() {
    return (
      <AddressContextMenu
        onEditButtonClick={() => {
          this.props.onEditButtonClick(this.props.ri.original);
        }}
        onDeleteButtonClick={() => {
          this.props.onDeleteButtonClick(
            this.props.ri.original.id,
            this.props.ri.original.account_id
          );
        }}
        address={this.props.ri.original}
        id={'Address' + this.props.ri.original.id}
      />
    );
  }
}

export default connect(
  (state) => ({}),
  (dispatch) => ({
    onEditButtonClick: bindActionCreators(setEditModeAddress, dispatch),
    onDeleteButtonClick: bindActionCreators(deleteAddress, dispatch),
  })
)(AddressContextMenuContainer);
